module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tl"
  }, [_c('content-card', [_c('h1', [_vm._v("\n        Orders list\n      ")]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.orders && _vm.orders.length > 0) ? _c('div', {
    staticClass: "order-list"
  }, _vm._l((_vm.orders), function(order) {
    return _c('div', {
      key: order._id,
      staticClass: "product flex bg-black-10 flex-wrap"
    }, [_c('router-link', {
      staticClass: "db w-80 pa2",
      staticStyle: {
        "flex-grow": "1"
      },
      attrs: {
        "to": {
          name: 'OrderDetails',
          params: {
            orderId: order._id
          }
        }
      }
    }, [_vm._v("\n              " + _vm._s(order._id) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "pa2 f4",
      staticStyle: {
        "align-self": "center"
      }
    }, [_vm._v(_vm._s(_vm.stateLabel(order.state)))]), _vm._v(" "), _c('div', {
      staticClass: "w-100 bg-white-20 pa2 f4 pb3",
      staticStyle: {
        "align-self": "center"
      }
    }, [_vm._v("Placed on : " + _vm._s(_vm.moment(order.placedOn).format('YYYY-MM-DD')))])], 1)
  })) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c9c6d9b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./admin/src/components/OrderList.vue
// module id = 251
// module chunks = 0